import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuSelectOptions, LuSelectUrlOptions } from 'lu-select';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType } from './formly-builder.models';

export class LuFormlySelectBuilder extends LuFormlyBuilder {
	protected type = FieldType.LU_SELECT;
	private items: any[] = [];
	private options: LuSelectOptions = null;
	private urlOptions: LuSelectUrlOptions;

	public setItems(items: any[]): this {
		this.items = items;
		return this;
	}

	public setOptions(options: LuSelectOptions): this {
		this.options = options;
		return this;
	}

	public setUrlOptions(urlOptions: LuSelectUrlOptions): this {
		this.urlOptions = urlOptions;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.luSelectItems = this.items;
		field.templateOptions.luSelectOptions = this.options;
		field.templateOptions.luSelectUrlOptions = this.urlOptions;
		field.templateOptions.luSelectOptions.placeholder = this.placeholder;

		return field;
	}
}
